import React, {PropTypes} from 'react';
import {Card} from 'routes/app/components';
import {FormattedMessage} from 'react-intl';
import './style.scss';

const Widget = ({children, title, onRefresh}) => {
    const actions = [
        <a href="#" key="refr" onClick={(e)=>{e.preventDefault(); onRefresh();}}><FormattedMessage id="refresh" /></a>
    ];
    return (
        <Card className="widget" title={title} actions={actions}>
            {children}
        </Card>
    );
};

Widget.propTypes = {
    onRefresh: PropTypes.func,
    children: PropTypes.node,
    title: PropTypes.node
};

export default Widget;